import React, { FC } from "react";

import { ILanguage } from "@/data/languages";
import { FloatedList } from "@/eworkitComponents";

import { SuggestedLanguageBadge } from "./SuggestedLanguageBadge";

interface ISuggestedLanguagesListProps {
  onClick: (language: ILanguage) => void;
  onCheckedClick: (language: ILanguage) => void;
  suggestedLanguages: ILanguage[];
  selectedLanguages?: ILanguage[];
}

export const SuggestedLanguagesList: FC<ISuggestedLanguagesListProps> = ({
  suggestedLanguages,
  onClick,
  onCheckedClick,
  selectedLanguages,
}) => {
  return (
    <FloatedList>
      {suggestedLanguages.map(language => (
        <SuggestedLanguageBadge
          key={language}
          language={language}
          onClick={() => onClick(language)}
          onCheckedClick={() => onCheckedClick(language)}
          isChecked={selectedLanguages?.some(l => l === language)}
        />
      ))}
    </FloatedList>
  );
};
